/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_ActiveInputs */

const zh_status_active = /** @type {(inputs: Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效中`)
};

const en_status_active = /** @type {(inputs: Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const es_status_active = /** @type {(inputs: Status_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Status_ActiveInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_active = /** @type {((inputs?: Status_ActiveInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_ActiveInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_active(inputs)
	if (locale === "en") return en_status_active(inputs)
	return es_status_active(inputs)
});